import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants.js'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { airPricePredictionQuery } from './priceWatchQueries/pricePredictionQuery.js'

export const pricePredictionRequest = async ({
  departDate,
  returnDate,
  origin,
  destination,
  minimumRetailPrice,
  isMobile,
  email,
  appVersion,
}) => {
  const operationName = 'airBuyPrediction'
  try {
    const pricePredictionResponse = await axios({
      url: getGraphURL({ operationName }),
      method: 'post',
      headers: {
        'apollographql-client-name': APOLLO_CLIENT_NAME,
        'apollographql-client-version': appVersion || 'development',
      },
      data: {
        variables: {
          criteria: {
            requestId: uuidv4(),
            departDate,
            returnDate,
            origin,
            destination,
            minimumRetailPrice,
            appCode: isMobile ? 'MOBILEWEB' : 'DESKTOP',
            email,
          },
        },
        query: airPricePredictionQuery,
      },
    })

    return pricePredictionResponse?.data?.data?.airBuyPrediction?.recommendations
  } catch (err) {
    return {
      status: 'ERROR',
      err: err,
    }
  }
}
